import axios from '@/plugins/axios'
import cookie from 'js-cookie'
export default {
  async install (Vue, defaultArea) {
    class SimulationAxios {
      static getUrl (url) {
        // 外链直接走自己的接口即可
        let declarePublish = cookie.get('declarePublish')
        if (url.includes('publicPublish') || !declarePublish || declarePublish === 'false') return url
        let disposeUrl = []
        url.split('/').forEach((u, i) => {
          if (i === 3) {
            disposeUrl.push('noauth')
          }
          disposeUrl.push(u)
        })
        return disposeUrl.join('/')
      }
      static get (url, param, config) {
        return axios.get(SimulationAxios.getUrl(url), param, config)
      }
      static post (url, param, config) {
        return axios.post(SimulationAxios.getUrl(url), param, config)
      }
      static delete (url, param, config) {
        return axios.delete(SimulationAxios.getUrl(url), param, config)
      }
      static methods (param) {
        param.url = SimulationAxios.getUrl(param.url)
        return axios(param)
      }
    }

    const publishAxios = param => SimulationAxios.methods(param)
    publishAxios.get = SimulationAxios.get
    publishAxios.post = SimulationAxios.post
    publishAxios.delete = SimulationAxios.delete
    Vue.$publishAxios = publishAxios
    Object.defineProperties(Vue.prototype, {
      $publishAxios: { get () { return publishAxios } }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/publishAxios/index.js